<template>
  <generic-modal
    :width="errorModal.width"
    :modalClass="errorModal.modalClass"
    :height="errorModal.height"
  >
    <template v-slot:header></template>
    <template v-slot:body>
      <div>
        <error-screen
          :data-image="staticImgBaseUrl + '/images/global/img-no-internet.svg'"
          :data-title="'No Internet connection'"
          :data-sub-title="'Please check your internet connection'"
          :data-cta="'Try again'"
        ></error-screen>
      </div>
    </template>
    <template v-slot:footer>
      <div></div>
    </template>
  </generic-modal>
</template>
<script>
import ErrorScreen from "./ErrorScreen.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
export default {
  components: { ErrorScreen },
  name: "NoInternetScreen",
  data() {
    return {
      staticImgBaseUrl,
      errorModal: {
        width: "100vw",
        height: "100%",
        modalClass: "full-screen-popup",
      },
    };
  },
  computed: {
  },
};
</script>
